module.exports = __webpack_public_path__ + "static/media/400413_01.8fb2a1b4.png";